import { render } from "./ToPageTop.vue?vue&type=template&id=cfd4675e&scoped=true&ts=true"
import script from "./ToPageTop.vue?vue&type=script&lang=ts"
export * from "./ToPageTop.vue?vue&type=script&lang=ts"

import "./ToPageTop.vue?vue&type=style&index=0&id=cfd4675e&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2791644585/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cfd4675e"]])

export default __exports__